import React from 'react'
import { Link } from 'react-router-dom'
import { RiFacebookCircleFill, RiTwitterXLine, RiLinkedinFill, RiGithubLine, RiCircleFill, RiDownloadLine, RiArrowRightCircleLine } from '@remixicon/react'
import profile from "../../assets/images/about/profile.png"
import SlideUp from '../../utlits/animations/slideUp';

const Hero = () => {
    return (
        <section id="about" className="about-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <SlideUp>
                            <div className="about-image-part">
                                <img src={profile} className="profile-picture" alt="Sobre mí" />
                                <h2>Marco Zúñiga</h2>
                                <p>10 años creando contenido 🎥</p>
                                <div className="about-social text-center">
                                    <ul>
                                        <li><Link to="https://www.facebook.com/profile.php?id=61565892719247"><RiFacebookCircleFill size={20} /></Link></li>
                                        <li><Link to="https://x.com/VISCO_team"><RiTwitterXLine size={20} /></Link></li>
                                        <li><Link to="https://www.linkedin.com/in/marcozcuadrado/"><RiLinkedinFill size={20} /></Link></li>
                                        <li><Link to="https://github.com/marcuspkz/"><RiGithubLine size={20} /></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </SlideUp>
                    </div>
                    <div className="col-lg-8">
                        <SlideUp>
                            <div className="about-content-part">
                                <p>¡Hola!</p>
                                <h2 className="custom-h2">
                                    Soy Marco Zúñiga, desarrollador fullstack y experto en Marketing Digital, RRSS y contenidos digitales.
                                </h2>
                                <div className="adress-field">
                                    <ul>
                                        <li className='d-flex align-items-center'><i><RiCircleFill size={14} /></i>Listo para ayudarte</li>
                                    </ul>
                                </div>
                                <div className="hero-btns">
                                    <Link to="/contact" className="theme-btn">¡Contacta conmigo!<i><RiArrowRightCircleLine size={16} /></i> </Link>
                                </div>
                            </div>
                        </SlideUp>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero